var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recharge-result"},[_c('p',[_c('Icon',{staticClass:"text-primary",attrs:{"type":"ios-checkmark-circle-outline"}}),_vm._v(" "+_vm._s(_vm.resultSuccess || 0))],1),_c('p',[_c('Icon',{staticClass:"text-danger",attrs:{"type":"ios-alert-outline"}}),_vm._v(" "+_vm._s(_vm.resultFail || 0))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }